import { ApolloClient } from '@apollo/client';

import { csrClient } from '../../apollo/api/avantArteClient';
import { CALCULATE_ORDER_PRICING } from '../../apollo/api/queries';
import {
  GeneratedOrdersPriceCalculation,
  GeneratedQueryCalculateOrderPricingArgs,
} from '../../types/generated';

export class AvantArteOrdersGateway {
  constructor(private client: ApolloClient<any>) {}

  async calculateOrderPricing(
    variables: GeneratedQueryCalculateOrderPricingArgs,
  ): Promise<GeneratedOrdersPriceCalculation> {
    const { data, errors } = await this.client.query<
      { calculateOrderPricing: GeneratedOrdersPriceCalculation },
      GeneratedQueryCalculateOrderPricingArgs
    >({
      query: CALCULATE_ORDER_PRICING,
      variables,
    });
    if (errors) {
      throw new Error(`Unable to calculate order price: ${errors[0].message}`);
    }
    return data.calculateOrderPricing;
  }
}

export const ordersGateway = new AvantArteOrdersGateway(csrClient);
